export default __webpack_public_path__ + "static/media/add.3e49a9c5.svg";